import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import FilterPanel from '../../TableView/components/FilterPanel';
import DataTable from '../../DataTable/components/DataTable';
import SubmittedEvidenceModal from './SubmittedEvidenceModal';
import DisputeEvidencePane from '../../DisputeEvidence/components/DisputeEvidencePane';
import { ToastContainer } from 'react-toastify';
import SlidingPane from "react-sliding-pane";

var _ = require('lodash');

import $ from 'jquery';
require('datatables.net-bs4');

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const decodeHtml = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const RESALE_DISPUTE_HEADINGS = {
  won: "Opendate won this dispute",
  lost: "Opendate lost this dispute",
  warning_closed: "This dispute is closed"
};

const PaymentDisputeManager = ({
  team,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  dataTableEl,
  dataTableElChanged,
  filters,
  filtersChanged,
  paymentDispute,
  paymentDisputeChanged
}) => {
  const reduceFilters = (filters) => {
    return filters.filter((filter) => {
      return filter.value.length > 0;
    }).reduce((params, filter) => {
      var newParam = {};
      newParam[filter.paramName] = filter.value;

      return Object.assign(params, newParam);
    }, {});
  }

  const reducedFilters = useMemo(() => {
    return (
      reduceFilters(filters)
    );
  }, [
    filters
  ]);

  const updateFilter = (filter, value) => {
    var updated = filters.map((item) => {
      if (item.paramName === filter.paramName) {
        var arrayValue = Array(value).flat();
        var newItem = Object.assign({}, item, {value: arrayValue});

        return newItem;
      }

      return item;
    })

    filtersChanged(updated);
  }

  const debouncedUpdateFilter = _.debounce((filter, value) => {
    updateFilter(filter, value);
  }, 200)

  const reloadTable = () => {
    if (dataTableEl) {
      $(dataTableEl).DataTable().ajax.reload();
    }
  }

  const closePane = () => {
    paymentDisputeChanged({});
    reloadTable();
  }

  const isSelected = Object.keys(paymentDispute).length > 0;
  const isNeedsResponse = paymentDispute.status === "needs_response";

  const resaleNet = paymentDispute.venue_billed_amount == null ? null : paymentDispute.venue_billed_amount - paymentDispute.venue_recovered_amount;

  return (
    <div>
      <ToastContainer icon={false} />
      <FilterPanel filters={filters}
                    clearFilterValues={
                      () => {
                        var updated = filters.map((item) => {
                          return Object.assign({}, item, {value: []})
                        })

                        filtersChanged(updated);
                      }
                    }
                    debouncedUpdateFilter={debouncedUpdateFilter}
                    updateFilter={updateFilter} />
      <div className='row'>
        <div className='col text-right'
              style={{"paddingBottom": "16px"}}>
          <a href="https://docs.stripe.com/disputes/responding" target="_blank">
            <strong>
              Need help?
            </strong>
          </a>
        </div>
      </div>
      <DataTable title={dataTableTitle}
                  dataSource={dataTableDataSource}
                  columns={dataTableColumns}
                  colGroup={
                    <colgroup>
                      <col span={1} style={{"width": "5%"}} />
                      <col span={1} style={{"width": "20%"}} />
                      <col span={1} style={{"width": "15%"}} />
                      <col span={1} style={{"width": "20%"}} />
                      <col span={1} style={{"width": "13.33%"}} />
                      <col span={1} style={{"width": "13.33%"}} />
                      <col span={1} style={{"width": "13.33%"}} />
                    </colgroup>
                  }
                  onTableElementSet={
                    (el) => {
                      dataTableElChanged(el);
                    }
                  }
                  rowCallback={
                    function(el, data){
                      let paymentDispute = JSON.parse(decodeHtml(data.json));

                      el.addEventListener("click", () => {
                        paymentDisputeChanged(paymentDispute);
                      });
                    }
                  }
                  reducedFilters={reducedFilters}
                  order={dataTableOrder} />

      <DisputeEvidencePane
        isOpen={isSelected && isNeedsResponse && !paymentDispute.resale_only}
        disputeId={paymentDispute.id}
        packetUrl={paymentDispute.id ? `/teams/${team.id}/payment_disputes/${paymentDispute.id}/evidence_packet` : null}
        submitUrl={paymentDispute.id ? `/teams/${team.id}/payment_disputes/${paymentDispute.id}/submit` : null}
        uploadTeamId={team.id}
        onClose={closePane}
        onSubmitted={reloadTable}
      />

      <SlidingPane
          isOpen={isSelected && (!isNeedsResponse || paymentDispute.resale_only)}
          className="sliding-pane-container-full-height"
          width={"420px"}
          hideHeader={true}
          onRequestClose={closePane}
        >
          <>
            <div className="row m-0">
              <div className="col-12"
                    style={{
                      "background": "var(--sl-bg-brand-solid)",
                      "padding": "20px 30px"
                    }}>
                <div className='row text-white' style={{"fontSize": "16px"}}>
                  <div className='col'>
                    <p className='mb-0'>
                      <strong>Dispute</strong>
                    </p>
                  </div>
                  <div className='col-xs-auto'
                        style={{"paddingRight": "15px"}}>
                    <a href="#"
                        onClick={
                          (e) => {
                            e.preventDefault();
                            paymentDisputeChanged({});
                          }
                        }>
                      <i className="fas fa-times text-white"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-0">
              <div className='col-12'
                    style={{"marginTop": "20px"}}>
                <div className='card border-0'
                      style={{"background": "var(--sl-bg-tertiary)", "borderRadius": "4px"}}>
                  <div className='card-body'
                        style={{"padding": "10px 22px 0px 22px"}}>
                    <table className='table table-sm table-borderless'>
                      <tbody>
                        <tr style={{"fontSize": "14px"}}>
                          <td>
                            <strong>Dispute details</strong>
                          </td>
                          <td className='text-right'>
                            {paymentDispute.status === "lost" ? (
                              <span style={{
                                "borderRadius": "4px",
                                "color": "var(--sl-text-error)",
                                "background": "var(--sl-bg-error-primary)",
                                "padding": "2px 5px",
                                "fontWeight": "600",
                                "fontSize": "12px"
                              }}>
                                Lost
                              </span>
                            ) : paymentDispute.status === "won" ? (
                              <span style={{
                                "borderRadius": "4px",
                                "color": "var(--sl-text-success)",
                                "background": "var(--sl-bg-success-primary)",
                                "padding": "2px 5px",
                                "fontWeight": "600",
                                "fontSize": "12px"
                              }}>
                                Won
                              </span>
                            ) : paymentDispute.status === "under_review" ? (
                              <span style={{
                                "borderRadius": "4px",
                                "color": "var(--sl-text-brand)",
                                "background": "var(--sl-bg-brand-primary)",
                                "padding": "2px 5px",
                                "fontWeight": "600",
                                "fontSize": "12px"
                              }}>
                                {`${paymentDispute.time_in_words_until_respond_by} till results`}
                              </span>
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </td>
                        </tr>
                        {paymentDispute.calendar_event && paymentDispute.calendar_event.id ? (
                          <tr style={{"fontSize": '12px'}}>
                            <td>Event</td>
                            <td className='text-right overflow-ellipsis'>
                              <a href={`/teams/${paymentDispute.team_id}/confirms/${paymentDispute.calendar_event.id}/dashboard`} target="_blank">
                                {paymentDispute.calendar_event.title}
                              </a>
                            </td>
                          </tr>
                        ) : null}
                        <tr style={{"fontSize": '12px'}}>
                          <td>Order ID</td>
                          <td className='text-right'>{paymentDispute.order_id}</td>
                        </tr>
                        <tr style={{"fontSize": '12px'}}>
                          <td>Amount</td>
                          <td className='text-right'>{formatter.format(paymentDispute.amount)}</td>
                        </tr>
                        <tr style={{"fontSize": '12px'}}>
                          <td>Reason</td>
                          <td className='text-right'>{paymentDispute.titleized_reason}</td>
                        </tr>
                        <tr style={{"fontSize": '12px'}}>
                          <td>Customer</td>
                          <td className='text-right'>{paymentDispute.email}</td>
                        </tr>
                        <tr style={{"fontSize": '12px'}}>
                          <td>Payment method</td>
                          <td className='text-right'>···· {paymentDispute.card_last4}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-0" style={{"marginTop": "15px"}}>
              {paymentDispute.resale_only ? (
                <div className='col-12'>
                  <p className='mb-0' style={{"fontSize": "16px"}}>
                    <strong>{RESALE_DISPUTE_HEADINGS[paymentDispute.status] || "Opendate is handling this dispute"}</strong>
                  </p>
                  <p className='mb-0' style={{"fontSize": "12px", "marginTop": "2px"}}>
                    {RESALE_DISPUTE_HEADINGS[paymentDispute.status]
                      ? "This dispute was on a fan-to-fan resale ticket. It didn't affect your balance."
                      : "This dispute is on a fan-to-fan resale ticket. It doesn't affect your balance, and you don't need to respond."}
                  </p>
                </div>
              ) : paymentDispute.status === "lost" ? (
                <div className='col-12'>
                  <p className='mb-0' style={{"fontSize": "16px"}}>
                    <strong>This dispute was lost</strong>
                  </p>
                  <p className='mb-0' style={{"fontSize": "12px", "marginTop": "2px"}}>
                    {paymentDispute.donation_account
                      ? `The issuing bank decided in favor of the cardholder. The disputed amount of ${formatter.format(paymentDispute.amount)} USD was debited from your donation account and will not be returned to you.`
                      : resaleNet == null
                        ? `The issuing bank decided in favor of the cardholder. The disputed amount of ${formatter.format(paymentDispute.amount)} USD and the dispute fee will not be returned to you.`
                        : resaleNet <= 0
                          ? "The issuing bank decided in favor of the cardholder. The fan's resale earnings covered what you were billed, so this dispute didn't cost you anything."
                          : paymentDispute.venue_recovered_amount > 0
                            ? `The issuing bank decided in favor of the cardholder. ${formatter.format(paymentDispute.venue_billed_amount)} USD was taken from your balance. The fan's resale earnings paid back ${formatter.format(paymentDispute.venue_recovered_amount)} USD, so this dispute cost you ${formatter.format(resaleNet)} USD.`
                            : `The issuing bank decided in favor of the cardholder. ${formatter.format(resaleNet)} USD, including the dispute fee, was taken from your balance and will not be returned.`}
                  </p>
                </div>
              ) : paymentDispute.status === "won" ? (
                <div className='col-12'>
                  <p className='mb-0' style={{"fontSize": "16px"}}>
                    <strong>You won the dispute!</strong>
                  </p>
                  <p className='mb-0' style={{"fontSize": "12px", "marginTop": "2px"}}>
                    {`The issuing bank decided in your favor${paymentDispute.human_closed_at ? ` on ${paymentDispute.human_closed_at}` : ""}. ${resaleNet == null
                      ? `The disputed amount of ${formatter.format(paymentDispute.amount)} USD, less any applicable Stripe fees will be returned to your ${paymentDispute.donation_account ? "donation account" : "account"}.`
                      : resaleNet <= 0
                        ? "The fan's resale earnings had already covered what you were billed, so your balance doesn't change."
                        : `The ${formatter.format(resaleNet)} USD this dispute cost you will be returned to your balance.`}`}
                  </p>
                </div>
              ) : paymentDispute.status === "under_review" ? (
                <div className='col-12'>
                  <p className='mb-0' style={{"fontSize": "16px"}}>
                    <strong>Your dispute evidence has been submitted</strong>
                  </p>
                  <p className='mb-0' style={{"fontSize": "12px", "marginTop": "2px"}}>
                    {`Your response${paymentDispute.human_submitted_at ? ` submitted on ${paymentDispute.human_submitted_at}` : ""} is being reviewed by the cardholder's issuing bank. We will notify you when we receive the issuing bank's decision, which can take up to three months.`}
                  </p>
                </div>
              ) : null}
              {paymentDispute.status && paymentDispute.status !== "needs_response" && !paymentDispute.resale_only ? (
                <div className='col-12' style={{"marginTop": "20px"}}>
                  {paymentDispute.human_submitted_at ? (
                    <SubmittedEvidenceModal team={team}
                                            paymentDispute={paymentDispute} />
                  ) : (
                    <p className='mb-0 small'
                        style={{"color": "var(--sl-text-tertiary)"}}>
                      No response was submitted for this dispute.
                    </p>
                  )}
                </div>
              ) : null}
            </div>
          </>
      </SlidingPane>
    </div>
  )
};

PaymentDisputeManager.propTypes = {
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
  dataTableTitle: PropTypes.string.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  dataTableOrder: PropTypes.array,
  dataTableColumns: PropTypes.array.isRequired,
  dataTableEl: PropTypes.object,
  dataTableElChanged: PropTypes.func.isRequired,
  filters: PropTypes.array,
  filtersChanged: PropTypes.func.isRequired,
  paymentDispute: PropTypes.object,
  paymentDisputeChanged: PropTypes.func.isRequired
};

export default PaymentDisputeManager;
